import type { SVGProps } from 'react';

export function CrownIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.794 20H4.317c-.553 0-.995-.34-1.106-.905L1 7.788c0-.452.11-.905.553-1.244.442-.226.884-.226 1.216 0l4.533 3.732 3.758-5.767a1.122 1.122 0 0 1 1.88 0l3.758 5.767 4.533-3.732a.854.854 0 0 1 1.216 0c.442.226.553.679.553 1.244l-2.211 11.307c0 .566-.553.905-1.106.905z" />
    </svg>
  );
}
